export const iconVariants = {
  blue: "fa fa-info",
  red: "fa fa-times",
  yellow: "fa fa-info",
  green: "fa fa-check",
  loading: "fa fa-cog fa-spin",
}
